import {default as Splash} from './Splash-Component'
export default Splash;